import { UseFormReturn } from 'react-hook-form'
import { InputFormValues } from '../types'
import { useEffect, useRef } from 'react'
import { useGetCodes } from '../api/useGetCodes'
import { DailyLogCode, EXTRA_INFO_CODES } from '@/types/logs'
import { useCombinedLogsTableFormStateStore } from '../store'

interface Props {
    form: UseFormReturn<InputFormValues>
}

export const useFormSync = ({ form }: Props) => {
    const { data: codes = [] } = useGetCodes()
    const code = form.watch('code')
    const description = form.watch('description')
    const { setReason } = useCombinedLogsTableFormStateStore()

    const lastCode = useRef<string | null>(null)

    useEffect(() => {
        // Code has changed
        if (code) {
            const prevCode = lastCode.current
            lastCode.current = code
            const codeActuallyChanged = prevCode !== null && prevCode !== code

            const reasons = codes.find((item) => item.code === code)?.reasons || []
            if (description && reasons && reasons.length > 0) {
                const matchingReason = reasons.find((reason) => reason.reasonDescription === description)
                if (!matchingReason) {
                    if (codeActuallyChanged) {
                        form.setValue('description', undefined, { shouldDirty: true })
                        form.setValue('selectedCodeTypeReasonId', undefined)
                        setReason(null)
                    }
                } else {
                    setReason(matchingReason)
                }
            }

            if (codeActuallyChanged) {
                if (!EXTRA_INFO_CODES.includes(code)) {
                    if (form.getValues()['strategy']) {
                        form.setValue('strategy', undefined, { shouldDirty: true })
                    }
                }

                if (Object.values(DailyLogCode).includes(code as DailyLogCode)) {
                    form.setValue('locationTo', undefined, { shouldDirty: true })
                }
            }
        } else if (lastCode.current) {
            // Code was cleared
            lastCode.current = null
            setReason(null)
            form.setValue('selectedCodeTypeReasonId', undefined)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code, codes, form])
}
